import React, { useRef, useState, useEffect } from "react";
import * as THREE from "three";
import useCustomizerStore from "../../../../state/customizer";
import styled from "styled-components";
import { animate } from "motion";
import { motion } from "framer-motion";
import { isMobile, useMobileOrientation } from "react-device-detect";

const titleArr = ["XLE", "LIMITED", "PLATINUM"];

function ModelNameFlipper() {
  const { isLandscape } = useMobileOrientation();
  const [title, setTitle] = useState(titleArr[model]);
  const model = useCustomizerStore((s) => s.model);
  const h1Ref = useRef();

  useEffect(() => {
    animate(
      h1Ref.current,
      { transform: "translateY(200px)", opacity: 0 },
      { duration: 0.7, easing: "ease" }
    )
      .finished.then(() => setTitle(titleArr[model]))
      .then(() =>
        animate(
          h1Ref.current,
          { transform: "translateY(0px)", opacity: 1 },
          { duration: 0.8, delay: 0.3, easing: "ease" }
        )
      );
  }, [model]);

  return (
    <Container
      textSize={isMobile ? "65px" : null}
      top={isMobile ? (isLandscape ? "34%" : "42%") : null}
      key="model-flipper-title"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div>
        <h1 ref={h1Ref}>{title}</h1>
      </div>
    </Container>
  );
}

const Container = styled(motion.div)`
  z-index: 905;
  position: absolute;
  top: ${(props) => props.top || "26%"};
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    h1 {
      font-family: "ToyotaType";
      font-size: ${(props) => props.textSize || "142px"};
      color: #555;
      text-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);
      font-weight: bold;
    }
  }
`;

export default React.memo(ModelNameFlipper);
